import { ImageThumbnailIcon } from '../svg';
import { useTranslation } from 'react-i18next';

interface PreviewAppearanceProps {
  title: string;
  description: string;
  imageUrl?: string;
  linkUrl: string;
}

export default function PreviewAppearance({
  title,
  description,
  imageUrl,
  linkUrl,
}: PreviewAppearanceProps) {
  const { t } = useTranslation();

  return (
    <>
      <div className="mb-4">
        <p className="text-base font-semibold text-[#172B4D]">
          {t('links.editAppearance')}
        </p>
      </div>
      <div className="border border-[#E5E9EB] rounded-[24px] p-4 flex items-start gap-3 lg:gap-4 w-full bg-[#f4f4f4] max-w-full">
        <div className="flex-shrink-0">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={String(t('common.preview'))}
              className="w-12 h-12 sm:w-20 sm:h-20 rounded-lg object-cover"
            />
          ) : (
            <div className="w-12 h-12 sm:w-20 sm:h-20 rounded-lg">
              <ImageThumbnailIcon className="w-12 h-12 sm:w-20 sm:h-20" />
            </div>
          )}
        </div>
        <div className="flex flex-col space-y-1 min-w-0 w-full">
          <div className="min-w-0 w-full">
            <p className="text-sm sm:text-base font-semibold text-[#172B4D] break-words">
              {title}
            </p>
          </div>
          <div className="min-w-0 w-full">
            <p className="text-sm sm:text-base text-black text-opacity-70 break-words">
              {description}
            </p>
          </div>
          <div className="min-w-0 w-full">
            <p className="text-xs sm:text-sm text-black text-opacity-70 break-words">
              {linkUrl}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
